import { Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { Subject } from 'rxjs';

@Injectable()
export class GlobalRenderTriggerService extends InjectableSuperclass {
  trigger$ = new Subject<void>();
}
